import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import download from 'downloadjs';
import moment from 'moment'

export default {
	name: 'PickUPCenterConfig',
	components: {
		BasicSelect,
		VueElementLoading,
		download
	},
	data: function() {
		return {
			createdBy:"",
			isLoadingUpload :false,
			isLoadingSearch :false,
			failed:[],
			fileDetails:[],
			addmodalShow: false,
			selectedConfig: '',
			configFileLogs: [],
			showModal: false,
			url: '',
      configFile:'',
      serr:'',
			filetypelist: [{
        value: 'fwd',
        text: 'FWD'
      }],
			filetypeitem: {},
      filetype: '',
			currentTab: 'upload',
      tabs: [{
					key: 'upload',
					value: 'PickUPCenterConfig',
          count: 0
				},
				{
					key: 'history',
					value: 'History'
				}
			],
			archiveLimit: 50
		}
	},
	created: function() {},
	computed: {
		currentTabComponent: function() {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		}
	},
	filters: {
    moment: function(date) {
      if (date == '' || date == null) {
        return '--'
      }
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
	moment1: function(timestamp){
		const convertTimestamp = new Date(timestamp).toLocaleString('en-GB', 
		{ 
			timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric', 
			hour: '2-digit', minute: '2-digit', second: '2-digit' })
			.replace(/(\d+)\/(\d+)\/(\d+), (\d+):(\d+):(\d+)/, '$1-$2-$3 $4:$5:$6');
		return convertTimestamp;
	},
  },
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.createdBy = userdetail[0].email;
	},
	methods: {
		secondFunction(tab){
			if(tab.key == "history"){
				this.getConfigFile();
			}
		},

	  uploadConfigFile(event){

			this.failed = [];
  		this.selectedFile = event.target[0].elements[1].files[0];

			if(this.selectedFile.size>5242880){
				this.$alertify.error("Failed! Upload Max File Size Should Not Be Greater Than 5 MB"); return false;

  		}else if ( /\.(csv)$/i.test(this.selectedFile.name) ||  /\.(zip)$/i.test(this.selectedFile.name)){
				this.isLoadingUpload = true;

      	const fd = new FormData();
				fd.append('lastModifiedBy', this.createdBy);
				fd.append('fileData', this.selectedFile);
				fd.append('fileName', this.selectedFile.name);

      	axios.post(apiUrl.api_url_hubops + 'pickUpConfigFileUpload', fd,
      	{
        	headers: {
          	'Authorization': 'authkey xB84JJ89Hd25'
        	}
      	})
      	.then(result => {

        	if(result.data.ResultCode == 100){
          	this.$alertify.success(result.data.ReturnMessage);
						this.resetForm();
        	}else{
						this.$alertify.error(result.data.ReturnMessage);
					}

					if(result && result.data.failed && result.data.failed.length > 0){
						this.failed = result.data.failed;
					}

					this.isLoadingUpload= false;
      	}, error => {
        	console.error(error)
        	this.isLoadingUpload= false;
        	this.$alertify.error('Error Occured');
   		 	});
    	}else{
      	this.isLoadingUpload= false;
      	this.$alertify.error("Failed! Please Upload Only Valid Format: .csv OR .zip");
    	}
    },

	  onUploadSubmit: function(res) {
			this.$validator.validateAll().then((result) => {
				if(result){
					this.uploadConfigFile(event);
					event.target.reset();
				}
			}).catch(() => {
			  this.$alertify.error('Error Occured');
			});
	  },

		async exportFailedConfig() {
     this.isLoadingUpload = true;

		 let fileName = 'failedConfig';
		 
	   let csvFields = {
				'shipment_type': 'shipment_type',
				'pickup_center': 'pickup_center',
				'mot': 'mot',
				'service_type': 'service_type',
				'shipment_destination': 'shipment_destination',
				'parent_city': 'parent_city',
				'destination_state': 'destination_state',
				'destination_zone': 'destination_zone',
				'dest_pincode': 'dest_pincode',
       			'next_bag_dest': 'next_bag_dest',
				'Reason' : 'Reason'
       
     }
	 
     // Map the failed data to match the csvFields keys
     const failedMapped = this.failed.map(item => ({
       shipment_type: item.shipment_type,
       pickup_center: item.pickup_center,
       mot: item.mot,
       service_type: item.service_type,
       shipment_destination: item.shipment_destination,
       parent_city: item.parent_city,
       destination_state: item.destination_state,
       destination_zone: item.destination_zone,
       dest_pincode: item.dest_pincode,
       next_bag_dest: item.next_bag_dest,
	   Reason:item.Reason
     }));

     await this.jsonToCSV(fileName, failedMapped, csvFields);
     this.isLoadingUpload = false;
   	},

		jsonToCSV(filename, data, csvFields, dateFilder = [], skipFilter = []) {
      var csvData = ''

	  if(filename!='failedConfig') csvData += 'Config Name' + ',' + filename + '\n';
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in csvFields) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvFields[key] + ','
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      //Data
      if (!Array.isArray(data)) {
        data = [data];
      }
      data.forEach(function(item) {
        for (let key in csvFields) {
          if (skipFilter.indexOf(key) == -1) {
            var value = item[key] !== undefined ? item[key] : '';
            var escapedCSV = value + '';
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilder.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
              else
                csvData += escapedCSV + ','
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },

		export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },

    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },

	  resetForm(event){
			this.isLoadingUpload = false;
			this.isLoadingSearch = false;
			this.filetypeitem = {};
      		this.filetype= '';
      		this.configFile= '';
			this.failed = [];
			this.$validator.reset();
			this.errors.clear();
	  },

		getConfigFile(){
			this.serr = '';
			this.isLoadingSearch = true; this.fileDetails = [];
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getPickUpConfigFile?archiveLimit='+this.archiveLimit,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(async result => {
					if (result.data.ResultCode == 100) {
						this.fileDetails = result.data.ResponseData;
						this.$alertify.success(result.data.ReturnMessage);
					} else {
						this.$alertify.error(result.data.ReturnMessage);
					}
					this.isLoadingSearch = false;
				}, error => {
					this.isLoadingSearch = false; console.error(error);
				})
		},

		selectFileType(item) {
			this.filetypeitem = item;
			this.filetype = item.value;
		},
		downloadConfigfromDB(file){

			let fileData = [];
			this.isLoadingSearch = true;

			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getPickUpConfigFileData?fileId='+file.id,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.isLoadingSearch = false;

						fileData = result.data.ResponseData;
						let fileName = file.filename;
						let csvFields = {
						'Shipment_Type': 'Shipment_Type',
						'Pickup_Center': 'Pickup_Center',
						'Mot': 'Mot',
						'Service_Type': 'Service_Type',
						'Shipment_Destination': 'Shipment_Destination',
						'Parent_City': 'Parent_City',
						'Destination_State': 'Destination_State',
						'Destination_Zone': 'Destination_Zone',
						'Dest_Pincode': 'Dest_Pincode',
       					'Next_Bag_Dest': 'Next_Bag_Dest'
	    				}

						this.jsonToCSV(fileName, fileData, csvFields);
						this.$alertify.success("Success");

					} else {
						this.isLoadingSearch = false;
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					this.isLoadingSearch = false;
					 console.error(error);
				})	
		},
		selectFile(data){
			this.selectedConfig=data;
			if(data.isactive)
			{
				this.$alertify.error('Config is already Active');
				return;
			}
			this.addmodalShow=true;
		},
		takeAction(){
			this.addmodalShow=false;
			this.updateConfigStatus();
		},
		updateConfigStatus(){
			
			this.isLoadingSearch=true;

			let fileInput ={
				"fileName" : this.selectedConfig.filename,
				"event" : "active",
				"createdBy" : this.createdBy,
			};

			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'updatePickUpConfigEvent',
				data: fileInput,
				headers: {
				  'authorization': 'authkey xB84JJ89Hd25',
				}
			  })
			  .then(result => {
				if (result.data.ResultCode == 100) {
					this.$alertify.success(result.data.ReturnMessage);
					this.getConfigFile();
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.isLoadingSearch=false;
			  }, error => {
				this.isLoadingSearch=false;
				console.error(error)
			  })

		},
		closeStatusModal()
		{
			this.addmodalShow=false;
			this.selectedConfig='';
		},
		getPickUpConfigAuditLogs(data)
		{
			this.isLoadingSearch = true;

			 axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'getPickUpConfigAuditLog?fileName='+data.filename,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25'
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.configFileLogs = result.data.ResponseData;
					this.isLoadingSearch = false;
					this.showModal=true;
				} else {
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.isLoadingSearch = false;
			}, error => {
				this.isLoadingSearch = false; console.error(error);
			})
		},
		closeModal() {
			this.showModal = false;
			this.configFileLogs=[];
		  }
	}
}



// WEBPACK FOOTER //
// ./src/views/components/PickUPCenterConfig/PickUPCenterConfig.js